// extracted by mini-css-extract-plugin
export default {"container":"Container_container__ITA5v","vertical_padding":"Container_vertical_padding__0p02Z"};